module.exports = __webpack_public_path__ + "static/media/s_taekwondo.94636171.mp3";